
@if (!hasData) {
  <div class="text-center">
    <img src="/assets/img/vazio.png" width="200px" alt="nao existem ocorrencias">
    <p class="legenda-vazio">Não existem ocorrências para os parâmetros passados.</p>
  </div>
}
@if (hasData) {
  <ng-content></ng-content>
}